<template>
  <v-card>
    <v-card-title>
      {{ $t("admin.user.auditPeriods") }}
    </v-card-title>

    <v-simple-table dense>
      <template #default>
        <thead>
          <tr>
            <th></th>
            <th>{{ $t("admin.user.auditPeriod.minimalFunds") }}</th>
            <th>{{ $t("admin.user.auditPeriod.stepModelFunds") }}</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="auditPeriod in auditPeriods" :key="auditPeriod.id">
            <td>
              {{ auditPeriod.year }}
            </td>
            <td>{{ minimalFunds(auditPeriod.funds) }}</td>
            <td>{{ stepModelFunds(auditPeriod.funds) }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { length, filter, propEq } from "ramda";

export default {
  props: {
    auditPeriods: {
      type: Array,
      required: true,
    },
  },

  methods: {
    minimalFunds(funds) {
      return length(filter(propEq("stepModel", false), funds));
    },

    stepModelFunds(funds) {
      return length(filter(propEq("stepModel", true), funds));
    },
  },
};
</script>
